const cache = new Map();
const DEFAULT_TTL_MS = 5 * 60 * 1000;

export const withCache = async (key, fetcher, ttl = DEFAULT_TTL_MS) => {
  const cached = cache.get(key);
  if (cached && Date.now() - cached.time < ttl) {
    return cached.value;
  }

  const value = await fetcher();
  cache.set(key, { value, time: Date.now() });
  return value;
};

export const clearRequestCache = () => cache.clear();
